import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Permissions } from '@app/Models/Permissions';
import { PermissionService } from '@app/Services';
import { Observable } from 'rxjs';
import { CopyConfigService } from '../Services';
import { MessageJobSeverity } from '@app/Enums';
import { AsyncPipe } from '@angular/common';
import { MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { RadioButtonCardComponent } from '../../../../Common/controls/radio-button-card/radio-button-card.component';
import { MatIcon } from '@angular/material/icon';
import { JobLiveViewComponent } from '../../../../Jobs/job.liveview.component';
import { CopyConfigExportImportComponent } from './copy-config-export-import/copy-config-export-import.component';
import { CopyConfigExportOnlyComponent } from './copy-config-export-only/copy-config-export-only.component';
import { CopyConfigImportOnlyComponent } from './copy-config-import-only/copy-config-import-only.component';

@Component({
    selector: 'app-copyconfig',
    templateUrl: './tenant.copyconfig.component.html',
    styleUrls: ['./tenant.copyconfig.component.scss'],
    imports: [MatRadioGroup, FormsModule, RadioButtonCardComponent, MatIcon, JobLiveViewComponent, CopyConfigExportImportComponent, CopyConfigExportOnlyComponent, CopyConfigImportOnlyComponent, AsyncPipe]
})
export class TenantCopyConfigComponent implements OnDestroy {
  copyConfigInProgress$: Observable<boolean>;
  hasCopyConfigStarted$: Observable<boolean>;
  copyConfigJobId$: Observable<string | null>;

  copyConfigOption = 'ExportImport';
  copyConfigOptions = [
    {
      value: 'ExportImport',
      label: 'Export & Import',
      shortDescription: 'Copy Config on the same environment (Recommended)',
      info: 'This job does a complete process of exporting and importing the selected configuration.' +
        'You are able to copy configuration only between tenants from the same environment.',
      descriptionIcon: 'info',
      icon: 'swap_vert'
    },
    {
      value: 'Export',
      label: 'Export Only',
      shortDescription: 'Copy Config across environments',
      info: 'This job only exports the selected configuration. ' +
        'It will give you an unique code to pass it to DevOps team in order to be able to import ' +
        'the configuration on a tenant from another environment.',
      descriptionIcon: 'warning',
      icon: 'arrow_upward'
    },
    {
      value: 'Import',
      label: 'Import Only',
      shortDescription: 'Copy Config across environments',
      info: 'This job only imports the selected configuration. ' +
        'It will require an unique code from DevOps team in order to be able to import ' +
        'the configuration on a tenant.',
      descriptionIcon: 'warning',
      icon: 'arrow_downward'
    },
  ];

  public constructor(private copyConfigService: CopyConfigService, private permissionService: PermissionService) {
    this.copyConfigInProgress$ = this.copyConfigService.copyConfigInProgress$.asObservable();
    this.hasCopyConfigStarted$ = this.copyConfigService.hasCopyConfigStarted();
    this.copyConfigJobId$ = this.copyConfigService.copyConfigJobId$.asObservable();
  }

  ngOnDestroy(): void {
    this.copyConfigService.reset();
  }

  hasPartialCopyConfigPermission(): boolean {
    return this.permissionService.hasPermission(Permissions.partialCopyConfig);
  }

  getCopyConfigSelectedOptionName(): string {
    return this.copyConfigOptions.find((option) => option.value === this.copyConfigOption)?.label;
  }

  jobComplete(event: MessageJobSeverity): void {
    if (event === MessageJobSeverity.CopyConfigSuccess || event === MessageJobSeverity.CopyConfigExportOnlySuccess) {
      this.copyConfigService.copyConfigInProgress$.next(false);
      this.copyConfigService.copyConfigFinalised$.next(true);
    }
  }
}
